<mat-card class="card">
  <mat-card-content class="cardContent">
    <div class="d-flex flex-column optionsContainer">
      <mat-checkbox data-testid="completed-status" [(ngModel)]="isCompleted">{{names.isCompleted}}</mat-checkbox>
      <mat-checkbox data-testid="incomplete-status" [(ngModel)]="isIncompleted">{{names.isIncompleted}}</mat-checkbox>
      <mat-checkbox data-testid="locked-status" [(ngModel)]="isLocked">{{names.isLocked}}</mat-checkbox>
      <mat-checkbox data-testid="unlocked-status" [(ngModel)]="isUnlocked">{{names.isUnlocked}}</mat-checkbox>
      <mat-checkbox data-testid="signed-dpr-uploaded-status" [(ngModel)]="isSignedDprDetailsUploaded">
        {{names.isSignedDprDetailsUploaded}}
      </mat-checkbox>
      <mat-checkbox data-testid="no-signed-dpr-uploaded-status" [(ngModel)]="isSignedDprDetailsNotUploaded">
        {{names.isSignedDprDetailsNotUploaded}}
      </mat-checkbox>
    </div>
  </mat-card-content>

  <mat-card-actions class="cardFooter">
    <button data-testid="apply-filters" mat-flat-button class="mat-secondary" (click)="onApply()">
      <mat-icon svgIcon="check"></mat-icon>
      <span i18n="@@dpr.dprFilters.btnApply">Apply</span>
    </button>
    <button data-testid="cancel-filters" mat-button color="primary" (click)="onCancel()">
      {{StaticMessage.CancelButton | staticMessage}}
    </button>
    <button
      *ngIf="isCompleted || isIncompleted || isLocked || isUnlocked || isSignedDprDetailsUploaded || isSignedDprDetailsNotUploaded"
      mat-button
      data-testid="clear-status-filters"
      color="primary"
      i18n="@@dpr.dprFilters.btnClear"
      (click)="onClear()"
    >
      Clear
    </button>
  </mat-card-actions>
</mat-card>
